import { useDefinitionsStore } from '../stores/definitionsStore'

import { registerSessionReset } from '@/features/auth'

/** Vocabulary is workspace/session scoped and is never persisted across logout. */
export function registerDefinitionsSessionReset(): () => void {
  return registerSessionReset(() => useDefinitionsStore().resetState())
}
